import(/* webpackMode: "eager" */ "/workspace/app/(marketing)/m/pricing/page.tsx");
